<template>
    <div>
        <div v-if="loading">
            <div class="spinner"></div>
        </div>

        <div v-else-if="errors.length" class="alert--error" >
            <p v-for="err in errors" :key="err"> {{ err }} </p>
        </div>

        <form v-if="!loading" class="form" @submit.prevent="save">
            <slot name="header"></slot>

            <div :class="wrapperClass">
                <div class="form__item">
                    <i class="form__icon icons icon-settings"></i>
                    <input v-model="experience.function_title" class="form__input--text" type="text" required :class="{ 'has-value': experience.function_title }"/>
                    <label class="form__label">{{$t('forms.work_experience.function_title')}}</label>
                </div>
                <div class="form__item">
                    <i class="form__icon icons icon-briefcase"></i>
                    <input v-model="experience.company_name" class="form__input--text" type="text" required :class="{ 'has-value': experience.company_name }"/>
                    <label class="form__label">{{$t('forms.work_experience.company_name')}}</label>
                </div>
                <div class="form__item">
                    <i class="form__icon icons icon-location-pin"></i>
                    <input v-model="experience.city" class="form__input--text" type="text" required :class="{ 'has-value': experience.city }"/>
                    <label class="form__label">{{$t('forms.work_experience.city')}}</label>
                </div>
                <div class="form__item">
                    <i class="form__icon icons icon-direction"></i>
                    <vue-select label="name" :options="workingAreas" v-model="experience.job_working_area" class="form__select" :class="{ 'has-value': experience.job_working_area }" >
                        <template slot="no-options">{{$t('forms.common.no_results')}}</template>
                    </vue-select>
                    <label class="form__label">{{$t('forms.work_experience.working_area')}}</label>
                </div>
                <div class="form__item">
                    <i class="form__icon icons icon-calendar"></i>
                    <input v-model="experience.start_date" class="form__input--text has-value" type="date"/>
                    <label class="form__label">{{$t('forms.work_experience.start_date')}}</label>
                </div>
                <div class="form__item">
                    <i class="form__icon icons icon-calendar"></i>
                    <input v-model="experience.end_date" class="form__input--text has-value" type="date"/>
                    <label class="form__label">{{$t('forms.work_experience.end_date')}}</label>
                </div>
                <div class="form__item">
                    <label class="form__top_label">{{$t('forms.work_experience.current_position')}}</label>
                    <div class="checkbox">
                        <input type="checkbox" class="checkbox__cb" id="trajectory_form__current_position" v-model="experience.current_position" />
                        <label for="trajectory_form__current_position" class="checkbox__label"> {{$t('common.yes')}}</label>
                    </div>
                </div>
            </div>

            <slot name="buttons" :isSaveDisabled="isSaveDisabled">
                <div class="form__buttons">
                    <button type="submit" class="form__button button--cta" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                </div>
            </slot>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop, Watch} from 'vue-property-decorator';
    import WorkExperience from '@/models/WorkExperience';

    import { LOAD_WORK_EXPERIENCE_RESOURCES } from '@/store/modules/work-experience-resources';

    @Component
    export default class WorkExperienceForm extends Vue {

        @Prop({ type: Array | String, default() {
            return [];
        } })
        wrapperClass;

        @Prop({ type: WorkExperience, default() {
            return new WorkExperience();
        } })
        experience;

        created() {
            this.errors = [];
            this.$store.dispatch(LOAD_WORK_EXPERIENCE_RESOURCES, {});
        }

        get isSaveDisabled() {

            return !this.experience.function_title || !this.experience.company_name || !this.experience.city ||
                    !this.experience.job_working_area || !this.experience.start_date;
        }

        saveLoading = false;

        get workingAreas() {
            return this.$store.state.work_experience_resources.working_areas;
        }

        get loading () {
            return this.saveLoading || this.$store.state.work_experience_resources.loading;
        }

        save() {
            this.errors = [];
            this.saveLoading = true;
            this.experience.save()
                .then(res => this.$emit('saved', res))
                .catch(
                    err => {
                        if (err.status === 422) {
                            this.errors = err.errors;
                        } else {
                            this.errors = [this.$t('common.unknown_error')];
                        }
                    })
                .then(() => this.saveLoading = false);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/dashboard/WorkExperienceForm.vue